import { render, staticRenderFns } from "./notifications-maling-export-complete.vue?vue&type=template&id=11d34d52&"
import script from "./notifications-maling-export-complete.vue?vue&type=script&lang=js&"
export * from "./notifications-maling-export-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports